import { Helmet } from "react-helmet-async"
import { useNavigate } from "../../../../../router"
import { Breadcrumbs } from "@sembark-travel/ui/router"
import { generatePath, useLocation } from "../../../../../router-utils"
import { UploadFileCsv } from "../../../../../DataDrive/TransportService"
import { TSheetFolder } from "../../../../../DataDrive"

export default function TransportServiceUploadPricesPage() {
	const location = useLocation()
	const navigate = useNavigate()
	function navigateToList() {
		return navigate("/data-drive", {
			replace: true,
		})
	}
	const folderDetails: TSheetFolder | undefined = location.state?.folderDetails
	return (
		<>
			<Helmet>
				<title>Upload Transport Service Prices</title>
			</Helmet>
			<Breadcrumbs
				key={"Upload Transport Service Prices"}
				title="Upload Transport Service Prices"
				items={[
					[generatePath("/data-drive"), "Transportation Prices"],
					["", "Upload CSV"],
				]}
			/>
			<UploadFileCsv
				folderDetails={folderDetails}
				action="CREATE"
				onSuccess={navigateToList}
				onCancel={navigateToList}
			/>
		</>
	)
}
